import { Role as CoreRole } from '@uzurv/core';
import { inheritSerialization } from 'cerialize';

@inheritSerialization(CoreRole)
export class Role extends CoreRole {

  static OnSerialized(instance: Role, json: any): void {
    super.OnSerialized(instance, json);
  }

  static OnDeserialized(instance: Role, json: any): void {
    super.OnDeserialized(instance, json);
  }
}
